import React from "react";
import { Tooltip, Button, Popconfirm, Icon } from "antd";
import { S3Image } from "aws-amplify-react";
import { Link } from "react-router-dom";
import * as Styled from "./styled";

export default ({ mapping, onRemoveMapping }) => {
  const { name, sku, catalogName, product_size, quantity, images, ignore } = mapping;

  if (ignore) {
    return (
      <Styled.Container>
        <p>
          <Icon type="info-circle" /> <strong>Ignored.</strong> Orders with this product will be ignored & hidden from orders list
        </p>
        { onRemoveMapping && (
          <div className="actions">
            <span />
            <Button type="primary" ghost onClick={() => onRemoveMapping(mapping)}>
              Remove from ignored list
            </Button>
          </div>
        )}
      </Styled.Container>
    )
  }
  return (
    <Styled.Container>
      <div style={{ marginBottom: 5 }}>
        Mapping: {name} | SKU: {sku}
      </div>
      <div>
        {catalogName}, {product_size} {quantity} each
      </div>
      <br />
      <div className="gallery">
        {images.map(i => (
          <Tooltip title={i.split("/")[1]}>
            <span>
              <S3Image level="public" imgKey={`resized/${i}`} />
            </span>
          </Tooltip>
        ))}
      </div>
      { onRemoveMapping && (
        <div className="actions">
          <div>
            <Icon type="info-circle" theme="twoTone" />{" "}
            <small>
              Updating a mapping will update all the products associated with the
              mapping.
            </small>
          </div>
          <div>
            <Popconfirm
              title="Are you sure you want to remove this mapping?"
              onConfirm={() => onRemoveMapping(mapping)}
            >
              <Button type="primary" ghost>
                Remove
              </Button>
            </Popconfirm>
            <span>&nbsp;</span>
            <Link to={`/mappings/${mapping.id}`}>
              <Button type="primary">Edit mapping</Button>
            </Link>
          </div>
        </div>
      )}
    </Styled.Container>
  );
};
